import { io, Socket } from "socket.io-client";
import { RuntimeConfig } from "@/lib/runtimeConfig";
import { logger } from "../logger";

let socketInstance: Socket | null = null;

/**
 * getSocketServerUrl
 * @returns Socket server url
 */
export const getSocketServerUrl = () =>
  RuntimeConfig.SOCKET_GATEWAY_URL?.trim();

/**
 * getSocketClient
 * @returns Socket instance
 */
export const getSocketClient = () => {
  const serverUrl = getSocketServerUrl();
  logger.log("[socket] serverUrl:", serverUrl);
  if (!serverUrl) {
    return null;
  }

  if (!socketInstance) {
    socketInstance = io(serverUrl, {
      autoConnect: false,
      upgrade: false,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 20000,
    });
  }

  return socketInstance;
};
